import { useEffect } from "react";
import { UtilsUseHistory } from "../utils/UtilsUseHistory";
import { useLoginOptionHooks } from "./login-option-hooks";
import { ApplicationState } from "../store";
import { LoginOptionState } from "../store/reducers/login-option-reducer";
import { useSelector } from "react-redux";
import { LocalStorage } from "../services/storage";
import {
  EMAIL_LOGIN_VERIFICATION_RESULT,
  REDIRECT,
} from "../constants/storage";
import { LayoutState } from "../store/reducers/layout-reducer";
import { ROUTES } from "../configs/routes";
import { UserState } from "../store/reducers/user-reducer";
import { useAuthProvider } from "./useAuthProvider";
import { useEmailSupport } from "../utils/email-supported/useEmailSupport";

export const useEmailLoginHooks = () => {
  const {
    toggleLoginModal,
    toggleEmailLoginModal,
    toggleEmailOtpModal,
    removeRedirectSession,
  } = useLoginOptionHooks();
  const { logout } = useAuthProvider();
  const { isEmailLoginSupported } = useEmailSupport();
  const isEmailLogin = useSelector<ApplicationState, boolean>(
    (state) => state.auth.type === "EMAIL"
  );
  const { isLoginModalOpen, isEmailLoginModalOpen, isEmailOtpModalOpen } =
    useSelector<ApplicationState, LoginOptionState>(
      (state) => state.loginOption
    );
  const { selectedCountry } = useSelector<ApplicationState, LayoutState>(
    (state) => state.layout
  );
  const { userCountryCode } = useSelector<ApplicationState, UserState>(
    (state) => state.user
  );
  const { go } = UtilsUseHistory();
  const isEmailLoginOngoing = isEmailLoginModalOpen || isEmailOtpModalOpen;
  const isLoginAttemptOngoing =
    isEmailLoginModalOpen || isEmailOtpModalOpen || isLoginModalOpen;

  // prevent login modal is open when user go back to page
  useEffect(() => {
    globalThis.onpopstate = () =>
      setTimeout(function () {
        if (isEmailLoginOngoing || isLoginModalOpen) {
          toggleEmailOtpModal(false);
          toggleLoginModal({ isLoginModalOpen: false });
          toggleEmailLoginModal(false);
          go(-1);
        }
      }, 0);
  }, [isEmailLoginOngoing, isLoginModalOpen]);

  // clear verification result when email login modal closed and verification failed
  useEffect(() => {
    const emailLoginVerificationResult = LocalStorage.get(
      EMAIL_LOGIN_VERIFICATION_RESULT
    );
    const isVerifying =
      emailLoginVerificationResult && emailLoginVerificationResult === "false";

    if (isVerifying && !isEmailLoginOngoing) {
      LocalStorage.remove(EMAIL_LOGIN_VERIFICATION_RESULT);
    }
  }, [isEmailLoginOngoing]);
  // if email login attempt is done, cleanup redirect session
  useEffect(() => {
    if (!isLoginAttemptOngoing) {
      removeRedirectSession();
    }
  }, [isLoginAttemptOngoing]);

  // Check if user is redirected back to home page after attempting
  // to directly access an authenticated route (deep link)
  useEffect(() => {
    if (!selectedCountry.code || !userCountryCode) return;
    // CHECK IF THE NEW selectedCountry doesn't support email login
    if (isEmailLogin && !isEmailLoginSupported(selectedCountry.code)) {
      // remove email session
      logout();
      sessionStorage.setItem(REDIRECT, ROUTES.MYDATA);
    }
  }, [userCountryCode, selectedCountry]);
};
